import { render, staticRenderFns } from "./k5.vue?vue&type=template&id=b9b169e8&scoped=true"
import script from "./k5.vue?vue&type=script&lang=ts"
export * from "./k5.vue?vue&type=script&lang=ts"
import style0 from "./k5.vue?vue&type=style&index=0&id=b9b169e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b169e8",
  null
  
)

export default component.exports